import { Injectable } from '@angular/core';
import { AuthenticationService } from '@tt-chvac/authentication';
import { IOfficeSelector, OfficeSelectorService } from '@tt-chvac/core-sales-web';
import { ReplaySubject } from 'rxjs';
import { AppConstants } from '../constants/constants';

@Injectable({
  providedIn: 'root',
})
export class GlobalFilterService {
  private defaultOffice$ = new ReplaySubject<IOfficeSelector>();
  private selectedOffice$ = new ReplaySubject<IOfficeSelector>();
  private officeSelectorList$ = new ReplaySubject<IOfficeSelector[]>();

  // fetches the office selector values on instantiation.
  constructor(
    private appConstants: AppConstants,
    private authenticationService: AuthenticationService,
    private officeSelectorService: OfficeSelectorService
  ) {
    this.authenticationService.isAuthenticated().then((value) => {
      if (value) {
        this.officeSelectorService.getOfficeSelectorList().subscribe((data) => {
          // If user does not have any sales office mapping do not redirect to logout screen
          // Allow the user to check whether user has readonly access
          data = data ?? [];
          localStorage.setItem('userHasSalesOffice', data.length > 0 ? 'true' : 'false');
          // .slice is used to clone the data array here to avoid just reference assignment.
          const officeList = data.slice(0);
          this.setDefaultOffice(officeList);
          this.setOfficeSelectorList(officeList);
        });
      }
    });
  }

  // it sets the selectedOffice$ with the new selected office
  setSelectedOffice(selectedOffice: IOfficeSelector) {
    this.selectedOffice$.next(selectedOffice);
  }

  // it  sets the officeSelectorList$ with the office list
  setOfficeSelectorList(officeList: IOfficeSelector[]) {
    this.officeSelectorList$.next(officeList);
  }

  public getDefaultOffice() {
    return this.defaultOffice$;
  }

  // returns the selectedOffice$ Subject for other components to subscribe to its changes
  getSelectedOffice() {
    return this.selectedOffice$;
  }

  // returns the officeSelectorList$ Subject for other components to subscribe to its changes
  getOfficeSelectorList() {
    return this.officeSelectorList$;
  }

  /**
   * Identify the default database for the current user
   *
   * If the logged in user has access to the support database, it is the default
   * Otherwise, attempt to use the office identified as a "home" sales office
   * If a home office isn't identified, use the first office from the available list
   */
  setDefaultOffice(officeList: IOfficeSelector[]): void {

    let defaultOffice = officeList.find((x) => x.drAddressId === this.appConstants.SUPPORT_DATABASE_DR_ADDRESS_ID);

    if (defaultOffice === undefined) {
      const officesWithSpecifiedHome = officeList.filter((x) => x.homeDrAddressId > 0 && x.homeDrAddressId === x.drAddressId);
      defaultOffice = officesWithSpecifiedHome.length > 0 ? officesWithSpecifiedHome[0] : officeList[0];
    }

    this.defaultOffice$.next(defaultOffice);
  }
}
